import { render, staticRenderFns } from "./PayoutCapitalist.vue?vue&type=template&id=b55de104&"
import script from "./PayoutCapitalist.vue?vue&type=script&lang=js&"
export * from "./PayoutCapitalist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports